import * as Yup from 'yup';
import { ValidationRules } from 'helpers/createFormConfig';
import { ProductFormValues } from './productFormValues';
import { ProductFormFieldNames } from './productFormFieldNames';
import { NumberWithUnit } from 'components/forms/NumberWithVariableUnitTypes';
import { TargetedSubscriberEnum } from 'api/product';

export const productValidationRules: ValidationRules<keyof ProductFormValues> = {
  [ProductFormFieldNames.Label]: Yup.string()
    .required('Le libellé est requis')
    .min(2, 'Le libellé doit contenir au moins 2 caractères'),
  [ProductFormFieldNames.Code]: Yup.string()
    .required('Le code est requis')
    .min(2, 'Le code doit contenir au moins 2 caractères'),
  [ProductFormFieldNames.Summary]: Yup.string()
    .required('La description est requise')
    .min(2, 'La description contenir au moins 2 caractères'),
  [ProductFormFieldNames.FullDescription]: Yup.string()
    .min(2, 'La description détaillée contenir au moins 2 caractères'),
  // Required on creation; ProductForm relaxes it when the edited product already has a logo.
  [ProductFormFieldNames.Logo]: Yup.mixed<File>()
    .required('Le logo du produit est requis'),
  [ProductFormFieldNames.BranchId]: Yup.string()
    .required('La branche est requise'),
  [ProductFormFieldNames.PersonId]: Yup.string()
    .required('Le nom du propriétaire est requis'),
  [ProductFormFieldNames.IsTacitRenewal]: Yup.boolean(),
  [ProductFormFieldNames.IsFixedFormula]: Yup.boolean(),
  [ProductFormFieldNames.TargetedSubscriber]: Yup.mixed<TargetedSubscriberEnum>()
    .oneOf(Object.values(TargetedSubscriberEnum))
    .required('Le souscripteur visé est requis'),
  [ProductFormFieldNames.NoticePeriodDuration]: Yup.mixed<NumberWithUnit>()
    .test(
      'notice-period-validation',
      'La durée de préavis est requise',
      function (value) {
        // Vérifier que le champ existe
        if (!value || value.value === null || value.value === undefined) {
          return this.createError({
            message: 'La durée de préavis est requise'
          });
        }

        // Vérifier que la valeur est un nombre positif
        if (typeof value.value !== 'number' || value.value < 0) {
          return this.createError({
            message: 'La valeur doit être un nombre positif'
          });
        }

        // Vérifier que l'unité est présente
        if (!value.unit) {
          return this.createError({
            message: 'L\'unité est requise'
          });
        }

        return true;
      }
    )
    .required('La durée de préavis est requise'),
  [ProductFormFieldNames.PlateformeIds]: Yup.array()
    .of(Yup.string().required())
    .min(1, 'Au moins une plateforme est requise')
    .required('Les plateformes sont requises'),
};
